import { toConsumableArray as _toConsumableArray } from './_virtual/_rollupPluginBabelHelpers.esm.js';
import { isBrowser } from '@costar-ui/utils';

var SHARE_CONTEXT_REGISTRY = '___CSG_SHARE_CONTEXT_REGISTRY___';
var ShareContext = function () {
  var instance = {};
  function getInstance() {
    if (isBrowser) {
      if (!window[SHARE_CONTEXT_REGISTRY]) {
        window[SHARE_CONTEXT_REGISTRY] = instance;
      }
      return window[SHARE_CONTEXT_REGISTRY];
    }
    return instance;
  }
  function getContext(contextId, fallbackContext) {
    var _ref;
    return contextId ? (_ref = getInstance()[contextId]) !== null && _ref !== void 0 ? _ref : fallbackContext ? fallbackContext() : undefined : fallbackContext ? fallbackContext() : undefined;
  }
  function isExistingContextId(contextId) {
    var instance = getInstance();
    return contextId in instance;
  }
  function registerGlobalContext(contextId, context) {
    if (isExistingContextId(contextId)) {
      throw new Error('Context already exist, we should not register the same context multiple time.');
    }
    var instance = getInstance();
    // eslint-disable-next-line no-console
    console.log("--- ShareContext adding ".concat(contextId, " ----"));
    instance[contextId] = context;
  }
  function deleteContext(contextId) {
    var instance = getInstance();
    if (contextId in instance) {
      // eslint-disable-next-line no-console
      console.log("--- ShareContext removing ".concat(contextId, " ----"));
      delete instance[contextId];
    }
  }
  function unregisterGlobalContext(contextId) {
    _toConsumableArray(Array.isArray(contextId) ? contextId : [contextId]).map(function (i) {
      return deleteContext(i);
    });
  }
  return {
    getContext: getContext,
    isExistingContextId: isExistingContextId,
    registerGlobalContext: registerGlobalContext,
    unregisterGlobalContext: unregisterGlobalContext
  };
}();
var ShareContext$1 = ShareContext;

export { ShareContext$1 as default };
//# sourceMappingURL=share-context.esm.js.map
